<template>
  <div id="app">
    <Navbar/>
    <router-view/>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'

export default {
  components: {
    Navbar
  }
}
</script>

<style lang="scss">
// Import Bulma's core -- but wait, didn't we also import Buefy (including Bulma)
// This is probably important to make our own color palette.
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #3BFFFC;
$primary-invert: findColorInvert($primary);
$success: #56E100;
$success-invert: findColorInvert($success);
$warning: #FFAE2C;
$warning-invert: findColorInvert($warning);
$danger: #FF15FF;
$danger-invert: findColorInvert($danger);
$spifi: #4099FF;
$spifi-invert: findColorInvert($spifi);

// Setup $colors to use as bulma classes (e.g. 'is-spifi')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "spifi": ($spifi, $spifi-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

// Import fonts
@import "/fonts/archia-light.css";
@import "/fonts/basiercircle-bold.css";

body, button, input, select, textarea {
  font-family: "archialight", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
h1, h2, h3, h4, h5, h6 {
  font-family: "basier_circlebold", -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
